import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerPlans from './ReportCustomerPlans'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportCustomerPlans} />
    </Switch>
)

export default Components
